export default __webpack_public_path__ + "static/media/06.8963009b.jpg";